'use client';

import type React from 'react';

import { useIsDarkMode } from 'hooks/useIsDarkMode';

const parseHexColor = (color: string | undefined): string | undefined => {
    if (!color) return undefined;
    const hex = color.startsWith('#') ? color.slice(1) : color;
    if (!/^[0-9a-fA-F]{3}$|^[0-9a-fA-F]{6}$/.test(hex)) return undefined;
    return `#${hex}`;
};

const getBackgroundColor = (override: string | undefined, isNewExplore: boolean, isDarkMode: boolean): string => {
    const parsed = parseHexColor(override);
    if (parsed) return parsed;
    if (isNewExplore && isDarkMode) return '#000000';
    // Resolve from globals.css directly (not the JS-injected --kalshi-palette-* layer,
    // which can drift from the page background painted by `html { background-color }`).
    return 'var(--surface-x10)';
};

interface GraphSectionWrapperProps {
    children: React.ReactNode;
    ref?: React.RefObject<HTMLDivElement | null>;
    isNewExplore?: boolean;
    forcingDarkMode?: boolean;
    backgroundColor?: string;
    transparent?: boolean;
}

const GraphSectionWrapper = ({
    children,
    ref,
    isNewExplore = false,
    forcingDarkMode = false,
    backgroundColor: backgroundColorOverride,
    transparent = false,
}: GraphSectionWrapperProps) => {
    const isDarkMode = useIsDarkMode() || forcingDarkMode;

    const backgroundColor = transparent
        ? 'transparent'
        : getBackgroundColor(backgroundColorOverride, isNewExplore, isDarkMode);

    return (
        <div
            style={{
                display: 'flex',
                width: '100%',
                height: '100%',
                flexDirection: 'column',
                position: 'relative',
                backgroundColor,
            }}
            ref={ref}
        >
            {children}
        </div>
    );
};

export default GraphSectionWrapper;
